import Yggdrasil from 'services/yggdrasil'

const state = {
    singleLearningPath: null,
    subscribedLearningPaths: null
}

const mutations = {
    ASSIGN_SINGLE_LEARNING_PATH (state, learningPath) {
        state.singleLearningPath = learningPath
    },
    UPDATE_SUBSCRIPTION_STATUS (state, status) {
        state.singleLearningPath.subscribed = status
    },
    ASSIGN_SUBSCRIBED_LEARNING_PATHS (state, subscribedLearningPaths) {
        const mappedSubscribedLearningPaths = subscribedLearningPaths.map(learningPath => {
            const newLearningPath = {
                ...learningPath,
                publishedDate: learningPath.publishDate
            }
            delete learningPath.publishDate
            return newLearningPath
        })
        state.subscribedLearningPaths = mappedSubscribedLearningPaths
    }
}

const actions = {
    async loadSingleLearningPath (store, slug) {
        let id = null
        if (typeof slug === 'string' && slug.includes('-')) {
            id = slug.split('-')[0]
        } else {
            id = slug
        }
        let learningPath = await Yggdrasil.loadSingleLearningPathById(id)
        store.commit('ASSIGN_SINGLE_LEARNING_PATH', learningPath)
    },
    async getSingleLearningPathWithId (store, id) {
        const learningPath = await Yggdrasil.loadSingleLearningPathById(id)
        return learningPath
    },
    async loadSubscribedLearningPaths (store) {
        const subscribedLearningPaths = await Yggdrasil.loadSubscribedLearningPaths()
        store.commit('ASSIGN_SUBSCRIBED_LEARNING_PATHS', subscribedLearningPaths)
    },
    async subscribeToLearningPath (store, learningPathId) {
        await Yggdrasil.subscribeToLearningPath(learningPathId)
        store.dispatch('loadSingleLearningPath', learningPathId)
        store.dispatch('loadSubscribedLearningPaths')
    },
    async unSubscribeToLearningPath (store, learningPathId) {
        await Yggdrasil.unSubscribeToLearningPath(learningPathId)
        store.dispatch('loadSingleLearningPath', learningPathId)
        store.dispatch('loadSubscribedLearningPaths')
    },
    async createLearningPathCertificate (store, learningPathId) {
        await Yggdrasil.createLearningPathCertificate(learningPathId)
    },
    clearSingleLearningPath (store) {
        store.commit('ASSIGN_SINGLE_LEARNING_PATH', null)
    },
    async hideOrRestoreUncompletedLearningPathFromList (store, { learningPathId, isHidden }) {
        await Yggdrasil.hideOrRestoreUncompletedLearningPathFromList({ learningPathId, isHidden })
    }
}

const getters = {
    getSingleLearningPath: (state) => state.singleLearningPath,
    getSingleLearningPathCourses: (state, getters) => {
        if (getters.getSingleLearningPath) {
            return getters.getSingleLearningPath.items.filter(item => item.type === 'course')
        }
        return []
    },
    getAllLearningPaths: (state) => state.learningPaths,
    getUncompletedLearningPaths: (state) => state.subscribedLearningPaths.filter((learningPath) => {
        return learningPath.hasUserCertificate === false && learningPath.canUserCreateCertificate === false
    }),
    getCompletedLearningPaths: (state) => state.subscribedLearningPaths.filter((learningPath) => {
        return learningPath.hasUserCertificate === true || learningPath.canUserCreateCertificate === true
    }),
    getSubscribedLearningPaths: (state) => state.subscribedLearningPaths
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
